import { h, s } from '../lib/dom';
import { createBrandGlyph } from './atom';

function portfolioLink(): HTMLAnchorElement {
  const a = h('a', { class: 'portfolio-link', href: '/portfolio/', 'aria-label': 'FunSource portfolio' });
  const arrow = s('svg', { viewBox: '0 0 24 24', class: 'portfolio-arrow', 'aria-hidden': 'true' });
  arrow.append(
    s('path', {
      d: 'M5 12 H19 M13 6 L19 12 L13 18',
      fill: 'none',
      stroke: 'currentColor',
      'stroke-width': 1.6,
      'stroke-linecap': 'round',
      'stroke-linejoin': 'round',
    }),
  );
  a.append(
    h('span', { class: 'portfolio-title' }, 'Portfolio'),
    h('span', { class: 'portfolio-meta' }, 'What we are working...'),
    arrow,
  );
  return a;
}

export function renderFooter(): HTMLElement {
  return h('footer', { class: 'footer' },
    h('div', { class: 'container footer-inner' },
      h('div', { class: 'brandline' },
        createBrandGlyph(22),
        h('span', {}, 'funsource'),
      ),
      portfolioLink(),
    ),
  );
}
